import type { RfqInvitationId, VendorRfqListParams } from "../types";

export const rfqKeys = {
  all: ["rfqs"] as const,
  lists: () => [...rfqKeys.all, "list"] as const,
  list: (params?: VendorRfqListParams) => [...rfqKeys.lists(), params] as const,
  details: () => [...rfqKeys.all, "detail"] as const,
  detail: (id: RfqInvitationId) => [...rfqKeys.details(), String(id)] as const,
};
